var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 60,
    viewBox: "0 0 87 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 59,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 59,
    rx: 15.5,
    stroke: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_36278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0088 30.2242C55.0088 29.2409 54.9304 28.5234 54.7608 27.7793H43.7305V32.2173H50.205C50.0745 33.3202 49.3696 34.9811 47.8032 36.0972L47.7812 36.2458L51.2688 38.996L51.5104 39.0205C53.7295 36.9344 55.0088 33.8649 55.0088 30.2242Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7296 41.9178C46.9016 41.9178 49.5645 40.8548 51.5095 39.0211L47.8023 36.0978C46.8102 36.8021 45.4787 37.2937 43.7296 37.2937C40.6228 37.2937 37.986 35.2076 37.046 32.3242L36.9083 32.3361L33.2818 35.193L33.2344 35.3272C35.1663 39.2337 39.1346 41.9178 43.7296 41.9178Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0452 32.3248C36.7972 31.5807 36.6537 30.7834 36.6537 29.9596C36.6537 29.1357 36.7972 28.3385 37.0322 27.5944L37.0256 27.4359L33.3537 24.5332L33.2336 24.5914C32.4374 26.2125 31.9805 28.0329 31.9805 29.9596C31.9805 31.8863 32.4374 33.7066 33.2336 35.3277L37.0452 32.3248Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7295 22.624C45.9356 22.624 47.4237 23.594 48.2722 24.4046L51.5878 21.1093C49.5515 19.1826 46.9015 18 43.7295 18C39.1346 18 35.1663 20.6841 33.2344 24.5906L37.033 27.5936C37.986 24.7102 40.6228 22.624 43.7295 22.624Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_36278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.04,
    height: 24,
    fill: "white",
    transform: "translate(31.9805 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIc);
export default __webpack_public_path__ + "static/media/google_ic.bb8b595a6e24903a3d9fc4a052c6342e.svg";
export { ForwardRef as ReactComponent };